export default "__VITE_ASSET__mpC9o6MQ__"